module.exports = __webpack_public_path__ + "static/media/icon-adult-male.3c335502.svg";